import { useLanguage } from '@/i18n/LanguageContext';
import { motion } from 'framer-motion';
import { usePartners, getTranslation } from '@/hooks/useSupabaseData';

const PartnersSlider = () => {
  const { t, lang } = useLanguage();
  const { data: partners } = usePartners();

  if (!partners?.length) return null;

  return (
    <section className="py-20 bg-secondary/20 overflow-hidden">
      <div className="container mx-auto px-4">
        <motion.div initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-gradient-gold mb-4">{t('section.partners_title')}</h2>
        </motion.div>
      </div>

      <div className="relative">
        <motion.div
          className="flex gap-8 w-max"
          animate={{ x: lang === 'en' ? ['0%', '-50%'] : ['0%', '50%'] }}
          transition={{ duration: 30, repeat: Infinity, ease: 'linear' }}
        >
          {[...partners, ...partners].map((partner, i) => {
            const tr = getTranslation(partner.partner_translations, lang);
            return (
              <div key={i} className="flex-shrink-0 w-48 h-24 rounded-xl bg-card/50 border border-border/50 flex items-center justify-center px-4 hover:border-primary/30 transition-colors overflow-hidden">
                {partner.logo_url ? (
                  <img src={partner.logo_url} alt={tr?.name || ''} className="max-w-full max-h-full object-contain" />
                ) : (
                  <span className="text-sm text-center text-muted-foreground font-medium">{tr?.name || ''}</span>
                )}
              </div>
            );
          })}
        </motion.div>
      </div>
    </section>
  );
};

export default PartnersSlider;
